import { render, staticRenderFns } from "./PurchaseHistory.vue?vue&type=template&id=188d89bc&scoped=true"
import script from "./PurchaseHistory.ts?vue&type=script&lang=ts&external"
export * from "./PurchaseHistory.ts?vue&type=script&lang=ts&external"
import style0 from "./PurchaseHistory.vue?vue&type=style&index=0&id=188d89bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188d89bc",
  null
  
)

export default component.exports